import styled from 'styled-components';
import tw from 'twin.macro';

const TradeInContainer = styled.div`
  ${tw`border border-gray-300 p-4 mb-4 border-solid`}
`;

const Title = styled.div`
  ${tw`font-bold text-sm mb-3`}
`;

const VehicleSection = styled.div`
  ${tw`mb-6`}
`;

const VehicleHeader = styled.div`
  ${tw`font-semibold text-sm mb-2`}
`;

const InfoRow = styled.div`
  ${tw`grid grid-cols-3 gap-2 mb-2`}
`;

const Label = styled.span`
  ${tw`text-sm`}
`;

const Input = styled.input`
  ${tw`border-b border-gray-400 w-full text-sm border-t-0 border-r-0 border-l-0`}
`;

const ValueSection = styled.div`
  ${tw`mb-2`}
`;

const TotalSection = styled.div`
  ${tw`mt-4 pt-4 border-t border-gray-300`}
`;

const TradeInVehicleSection = () => {
  return (
    <TradeInContainer>
      <Title>Trade-In Vehicle(s)</Title>

      <VehicleSection>
        <VehicleHeader>1. Vehicle 1</VehicleHeader>
        <InfoRow>
          <div>
            <Label>Year</Label>
            <Input type="text" defaultValue="N/A" />
          </div>
          <div>
            <Label>Make</Label>
            <Input type="text" defaultValue="N/A" />
          </div>
          <div>
            <Label>Model</Label>
            <Input type="text" defaultValue="N/A" />
          </div>
        </InfoRow>
        <InfoRow>
          <div>
            <Label>VIN</Label>
            <Input type="text" defaultValue="N/A" />
          </div>
          <div>
            <Label>Odometer</Label>
            <Input type="text" defaultValue="N/A" />
          </div>
        </InfoRow>

        <ValueSection>
          <Label>a. Agreed Value of Property</Label>
          <Input type="text" defaultValue="N/A" />
        </ValueSection>
        <ValueSection>
          <Label>b. Buyer/Co-Buyer Retained Trade Equity</Label>
          <Input type="text" defaultValue="N/A" />
        </ValueSection>
        <ValueSection>
          <Label>c. Agreed Value of Property Being Traded-In (a-b)</Label>
          <Input type="text" defaultValue="N/A" />
        </ValueSection>
        <ValueSection>
          <Label>d. Prior Credit or Lease Balance</Label>
          <Input type="text" defaultValue="N/A" />
        </ValueSection>
        <ValueSection>
          <Label>e. Net Trade-In (c-d) (must be ≥ 0 for buyer/co-buyer to retain equity)</Label>
          <Input type="text" defaultValue="N/A" />
        </ValueSection>
      </VehicleSection>

      <VehicleSection>
        <VehicleHeader>2. Vehicle 2</VehicleHeader>
        <InfoRow>
          <div>
            <Label>Year</Label>
            <Input type="text" defaultValue="N/A" />
          </div>
          <div>
            <Label>Make</Label>
            <Input type="text" defaultValue="N/A" />
          </div>
          <div>
            <Label>Model</Label>
            <Input type="text" defaultValue="N/A" />
          </div>
        </InfoRow>
        <InfoRow>
          <div>
            <Label>VIN</Label>
            <Input type="text" defaultValue="N/A" />
          </div>
          <div>
            <Label>Odometer</Label>
            <Input type="text" defaultValue="N/A" />
          </div>
        </InfoRow>

        <ValueSection>
          <Label>a. Agreed Value of Property</Label>
          <Input type="text" defaultValue="N/A" />
        </ValueSection>
        <ValueSection>
          <Label>b. Buyer/Co-Buyer Retained Trade Equity</Label>
          <Input type="text" defaultValue="N/A" />
        </ValueSection>
        <ValueSection>
          <Label>c. Agreed Value of Property Being Traded-In (a-b)</Label>
          <Input type="text" defaultValue="N/A" />
        </ValueSection>
        <ValueSection>
          <Label>d. Prior Credit or Lease Balance</Label>
          <Input type="text" defaultValue="N/A" />
        </ValueSection>
        <ValueSection>
          <Label>e. Net Trade-In (c-d) (must be ≥ 0 for buyer/co-buyer to retain equity)</Label>
          <Input type="text" defaultValue="N/A" />
        </ValueSection>
      </VehicleSection>

      <TotalSection>
        <ValueSection>
          <Label>Total Agreed Value of Property Being Traded-In (1c+2c)</Label>
          <Input type="text" defaultValue="N/A" />
        </ValueSection>
        <ValueSection>
          <Label>Total Prior Credit or Lease Balance (1d+2d)</Label>
          <Input type="text" defaultValue="N/A" />
        </ValueSection>
        <ValueSection>
          <Label>Total Net Trade-In (1e+2e)</Label>
          <Input type="text" defaultValue="N/A" />
        </ValueSection>
        <div className="text-xs text-gray-600 mt-1">
          (See item 6A-6C in the Itemization of Amount Financed)
        </div>
      </TotalSection>
    </TradeInContainer>
  );
};

export default TradeInVehicleSection;
